import { useEffect } from 'react'
import { setSideNavCollapsed } from '@/store/slices/ui-state.slice'
import { useAppDispatch } from '@/store/store-hooks'
import { loadSideNavContractedFromLocalStorage } from '@/util/storage-utils'

/**
 * Temporarily collapses navigation while a workspace is open. Restore the latest saved
 * preference on exit: entry state may be another workspace's temporary collapse,
 * and manual toggles while mounted may change the user's preference.
 */
export function useCollapseSideNavWhileMounted() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(setSideNavCollapsed(true))
    return () => {
      dispatch(setSideNavCollapsed(loadSideNavContractedFromLocalStorage() ?? false))
    }
  }, [dispatch])
}
